import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AssessmentRef } from "./AssessmentRef";
import type { AssessmentStaff } from "./AssessmentStaff";
import type { PersonSkillChangeDTOBase } from "./PersonSkillChangeDTOBase";
import type { PersonSkillStaff } from "./PersonSkillStaff";
import type { PersonStaff } from "./PersonStaff";
import type { ProfilePersonBase } from "./ProfilePersonBase";
import type { SkillRef } from "./SkillRef";
import type { SkillStaff } from "./SkillStaff";
import type { TrackedBase } from "./TrackedBase";

export class PersonSkillChangeStaff implements PersonSkillChangeDTOBase, TrackedBase, ProfilePersonBase {
  constructor(public readonly changeId: number, public readonly assignId: PersonSkillStaff | null, public readonly changeAction: string, public readonly changedBy: string, public readonly assessmentId: AssessmentStaff | null, public readonly classSkillAssignId: number | null, public readonly skillId: SkillStaff | null, public readonly instructor: string | null, public readonly comments: string | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly personId: PersonStaff | null, public readonly assessmentIdTargetIds: AssessmentRef | null, public readonly skillIdTargetIds: SkillRef, public readonly assessmentName: string | null, public readonly skillName: string | null) {
    this.cbiServiceContext = null;
    this.assignIdLoaded = this.assignId != null;
    this.assignIdCached = this.assignId;
    this.assessmentIdLoaded = this.assessmentId != null;
    this.assessmentIdCached = this.assessmentId;
    this.skillIdLoaded = this.skillId != null;
    this.skillIdCached = this.skillId;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private assignIdLoaded: boolean;
  private assignIdCached: PersonSkillStaff | null;
  private assessmentIdLoaded: boolean;
  private assessmentIdCached: AssessmentStaff | null;
  private skillIdLoaded: boolean;
  private skillIdCached: SkillStaff | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  async assignIdLazy(): Promise<PersonSkillStaff> {
    if (!this.assignIdLoaded) {
      this.assignIdCached = await this.cbiServiceContext!.personService().getPersonSkillChangeStaffAssignId(this.changeId);
      this.assignIdLoaded = true;
    }
    return this.assignIdCached!;
  }
  async assessmentIdLazy(): Promise<AssessmentStaff | null> {
    if (!this.assessmentIdLoaded) {
      this.assessmentIdCached = await (this.assessmentIdTargetIds != null ? this.cbiServiceContext!.personService().getAssessmentStaff(this.assessmentIdTargetIds.assessmentId) : Promise.resolve(null));
      this.assessmentIdLoaded = true;
    }
    return this.assessmentIdCached;
  }
  async skillIdLazy(): Promise<SkillStaff> {
    if (!this.skillIdLoaded) {
      this.skillIdCached = await this.cbiServiceContext!.personService().getSkillStaff(this.skillIdTargetIds.skillId);
      this.skillIdLoaded = true;
    }
    return this.skillIdCached!;
  }
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personService().getPersonSkillChangeStaffPersonId(this.changeId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
}
